import { gql } from '@apollo/client';

const NodeContentQueryEn = gql`
query MyQuery {
  nodePages(first: 100, langcode: "en") {
    nodes {
      __typename
      bannerImage {
        url
        alt
      }
      body {
        value
      }
      imageAbout {
        url
      }
      path
      title
    }
  }
}
`;
export default NodeContentQueryEn;